import { StringMask } from '@/utils';
import { NInput } from 'naive-ui';
import { defineComponent, ref, watch } from 'vue';

const MAX_INPUT_LENGTH = 14;

export const AppInputCnpj = defineComponent({

	props: {
		modelValue: String,
		readonly: Boolean,
	},
	emits: ['update:modelValue', 'update:value'],

	setup(props, { emit }) {
		const mask = '00.000.000/0000-00';
		const fieldMask = new StringMask({ mask: mask });
		const maskedValue = ref(
			props.modelValue ? fieldMask.apply(props.modelValue.toString()).maskedValue : '',
		);
		const isReadonly = props.readonly;

		watch(
			() => props.modelValue,
			(v) => {
				if (!v) {
					maskedValue.value = '';
					return;
				}

				const digits = v.toString().replace(/\D/g, '');
				maskedValue.value = fieldMask.apply(digits).maskedValue;
			},
			{ immediate: true },
		);

		function handleInput(value: string) {
			const response = fieldMask.apply(value);
			const parsedValue = response.unmaskedValue;
			maskedValue.value = response.maskedValue;

			emit('update:modelValue', parsedValue);
			emit('update:value', parsedValue);
		}

		return () => (
			<NInput
				placeholder={mask}
				inputProps={{
					maxlength: MAX_INPUT_LENGTH,
					autocomplete: 'cnpj',
					inputmode: 'numeric',
				}}
				onInput={handleInput}
				value={maskedValue.value}
				disabled={isReadonly}
			/>
		);
	},
});

export default AppInputCnpj;
